import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { BACKEND_PIVOT } from 'core/constants/endpoints'

function getPlanDetails(planId: string | number, stateAcronym: string) {
  const url = `${BACKEND_PIVOT}/plan-details/find/planId/${planId}/${stateAcronym}`

  return planId && stateAcronym ? fetchJSONHandleError({ url }) : Promise.resolve(null)
}

export default getPlanDetails
